import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, BellIcon, MessageSquareIcon } from 'lucide-react';
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  // Mock authentication state
  const isAuthenticated = true;
  const user = {
    name: 'John Doe',
    role: 'buyer'
  };
  return <nav className="bg-white shadow-sm" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="flex justify-between h-16" data-id="element-54">
          <div className="flex items-center" data-id="element-55">
            <Link to="/" className="flex-shrink-0 flex items-center" data-id="element-56">
              <div className="bg-white p-1 rounded-lg shadow-md" data-id="element-57">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9YiZ8fYR9MF9BFf8vhx3gU/Kastom_Printing_Logo.png" alt="Kastom Printing Logo" className="h-14 w-auto" data-id="element-58" />
              </div>
              <span className="ml-2 text-xl font-bold text-gray-900 sr-only" data-id="element-59">
                Kastom Printing
              </span>
            </Link>
            <div className="hidden md:ml-10 md:flex md:space-x-8" data-id="element-60">
              <Link to="/dashboard" className={`${location.pathname === '/dashboard' ? 'border-red-600 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'} inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`} data-id="element-61">
                Dashboard
              </Link>
              <Link to="/products" className={`${location.pathname.startsWith('/products') ? 'border-red-600 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'} inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`} data-id="element-62">
                Products
              </Link>
              <Link to="/messages" className={`${location.pathname === '/messages' ? 'border-red-600 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'} inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium`} data-id="element-63">
                Messages
              </Link>
            </div>
          </div>
          <div className="hidden md:flex items-center" data-id="element-64">
            {isAuthenticated ? <div className="ml-4 flex items-center md:ml-6" data-id="element-65">
                <button className="p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-66">
                  <span className="sr-only" data-id="element-67">View notifications</span>
                  <BellIcon className="h-6 w-6" data-id="element-68" />
                </button>
                <button className="p-1 ml-3 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-69">
                  <span className="sr-only" data-id="element-70">Messages</span>
                  <MessageSquareIcon className="h-6 w-6" data-id="element-71" />
                </button>
                <Link to="/profile" className="ml-3 flex items-center text-sm font-medium text-gray-700 hover:text-gray-800" data-id="element-72">
                  <div className="h-8 w-8 rounded-full bg-red-100 flex items-center justify-center text-red-600 font-bold" data-id="element-73">
                    {user.name.charAt(0)}
                  </div>
                  <span className="ml-2" data-id="element-74">{user.name}</span>
                </Link>
              </div> : <div className="ml-4 flex items-center md:ml-6" data-id="element-75">
                <Link to="/login" className="text-gray-500 hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium" data-id="element-76">
                  Log in
                </Link>
                <Link to="/register" className="ml-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium" data-id="element-77">
                  Sign up
                </Link>
              </div>}
          </div>
          <div className="-mr-2 flex items-center md:hidden" data-id="element-78">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-500" aria-expanded="false" data-id="element-79">
              <span className="sr-only" data-id="element-80">Open main menu</span>
              {mobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-81" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-82" />}
            </button>
          </div>
        </div>
      </div>
      {mobileMenuOpen && <div className="md:hidden" data-id="element-83">
          <div className="pt-2 pb-3 space-y-1" data-id="element-84">
            <Link to="/dashboard" className={`${location.pathname === '/dashboard' ? 'bg-red-50 border-red-600 text-red-700' : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`} data-id="element-85">
              Dashboard
            </Link>
            <Link to="/products" className={`${location.pathname.startsWith('/products') ? 'bg-red-50 border-red-600 text-red-700' : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`} data-id="element-86">
              Products
            </Link>
            <Link to="/messages" className={`${location.pathname === '/messages' ? 'bg-red-50 border-red-600 text-red-700' : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'} block pl-3 pr-4 py-2 border-l-4 text-base font-medium`} data-id="element-87">
              Messages
            </Link>
          </div>
          {isAuthenticated ? <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-88">
              <div className="flex items-center px-4" data-id="element-89">
                <div className="flex-shrink-0" data-id="element-90">
                  <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center text-red-600 font-bold" data-id="element-91">
                    {user.name.charAt(0)}
                  </div>
                </div>
                <div className="ml-3" data-id="element-92">
                  <div className="text-base font-medium text-gray-800" data-id="element-93">
                    {user.name}
                  </div>
                  <div className="text-sm font-medium text-gray-500 capitalize" data-id="element-94">
                    {user.role}
                  </div>
                </div>
              </div>
              <div className="mt-3 space-y-1" data-id="element-95">
                <Link to="/profile" className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100" data-id="element-96">
                  Your Profile
                </Link>
                <button className="w-full text-left block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100" data-id="element-97">
                  Sign out
                </button>
              </div>
            </div> : <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-98">
              <div className="flex items-center px-4 space-x-3" data-id="element-99">
                <Link to="/login" className="block text-gray-500 hover:text-gray-800 text-base font-medium" data-id="element-100">
                  Log in
                </Link>
                <Link to="/register" className="block bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-base font-medium" data-id="element-101">
                  Sign up
                </Link>
              </div>
            </div>}
        </div>}
    </nav>;
}